import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/usergroups';

const UserGroupService = {

  deleteUserGroup( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  getUserGroups( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getUserGroup( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  saveUserGroup( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateUserGroup( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default UserGroupService;



// WEBPACK FOOTER //
// ./services/UserGroupService.js